import { api as teacherApi } from './auto-generated/teacher'
teacherApi.enhanceEndpoints({
  endpoints: {
    teacherCloseTeacherHomepage: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        let patchResult
        try {
          const { data } = await queryFulfilled
          const { data: teacherHomepage } = await dispatch(
            teacherApi.endpoints.teacherGetTeacherHomepage.initiate(undefined, {
              forceRefetch: true,
            }),
          )
          console.log('this new homepage', teacherHomepage)
          patchResult = dispatch(
            teacherApi.util.updateQueryData('teacherGetTeacherHomepage', args, (draft) => {
              Object.assign(draft, teacherHomepage)
            }),
          )
        } catch {
          patchResult?.undo()
        }
      },
    },
  },
})

export { teacherApi }
